module.exports = __webpack_public_path__ + "img/alipay.445a89f6.png";